<template>
  <div class="zgq-container">
    <template v-if="total > 0 || scrollFlag">
      <Block
        :block="item"
        v-for="item in blockList"
        :key="item.id"
      ></Block>
      <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd"/>
    </template>
    <NoData  v-if="total <= 0 && !scrollFlag" style="left: 0"></NoData>
  </div>
</template>

<script>
import NoData from "@/views/PCView/search/components/NoData.vue";
import Block from "./components/Block.vue";
import Scroll from "@/components/paging/scroll";
export default {
  components: {
    Block,
    NoData,
    Scroll
  },
  data() {
    return {
      scrollFlag: false,
      isEnd: false,
      blockList: [],
      total: 0,
      pageNum: 1,
      params: {
        pageNo: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    this.getLetterList(this.params);
  },
  mounted() {
    this.$bus.$on("mainScroll", this.handlePager);
  },
  beforeDestroy() {
    this.$bus.$off("mainScroll", this.handlePager);
  },
  methods: {
    handlePager() {
      let containerHeight =
        document.documentElement.clientHeight +
        document.documentElement.scrollTop;
      let scrollHeight = document.documentElement.scrollHeight;
      if (containerHeight + 1 >= scrollHeight && !this.scrollFlag && !this.isEnd ) {
        this.getLetterList({
          ...this.params,
          pageNo: ++this.pageNum,
        });
      }
    },
    async getLetterList(data) {
      this.scrollFlag = true
      this.isEnd = false
      const resp = await this.$apis.zgqServe.getLetterList(data);
      this.total = +resp.page.total;
      this.blockList.push(...resp.page.list);
      this.scrollFlag = false
      this.isEnd = this.pageNum >= this.total / 10
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 890px;
  position: relative;
}
</style>
